const state = {
	data: [],
};

const getters = {
};

const mutations = {
	SET(state, objects) {
		state.data = objects
		state.data.sort((a, b) => (a.attributes.last_name.toLowerCase() > b.attributes.last_name.toLowerCase()) ? 1 : ((b.attributes.last_name.toLowerCase() > a.attributes.last_name.toLowerCase()) ? -1 : 0));
	},
	INSERT(state, object) {
		state.data.push(object)
		state.data.sort((a, b) => (a.attributes.last_name.toLowerCase() > b.attributes.last_name.toLowerCase()) ? 1 : ((b.attributes.last_name.toLowerCase() > a.attributes.last_name.toLowerCase()) ? -1 : 0));
	},
	DELETE(state, object) {
		state.data = state.data.filter((elem) => {
			return elem.id != object.id
		})
		state.data.sort((a, b) => (a.attributes.last_name.toLowerCase() > b.attributes.last_name.toLowerCase()) ? 1 : ((b.attributes.last_name.toLowerCase() > a.attributes.last_name.toLowerCase()) ? -1 : 0));
	},
	REPLACE(state, object) {
		const oldObject = state.data.filter(item => item.id == object.id)
		const index = state.data.indexOf(oldObject[0]);
		if (index > -1) {
			state.data.splice(index, 1, object);
		}
		state.data.sort((a, b) => (a.attributes.last_name.toLowerCase() > b.attributes.last_name.toLowerCase()) ? 1 : ((b.attributes.last_name.toLowerCase() > a.attributes.last_name.toLowerCase()) ? -1 : 0));
	},
};

const actions = {
	set({ commit }, objects) {
		commit('SET', objects)
	},
	insert({ commit }, object) {
		commit('INSERT', object)
	},
	delete({ commit }, object) {
		commit('DELETE', object)
	},
	replace({ commit }, object) {
		commit('REPLACE', object)
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};